export default {
  users: {
    list_of_users: 'List of users',
    role: 'Role',
    number_of_authorized_exhibitors: 'Number of authorized exhibitors',
    firstname: 'Firstname',
    lastname: 'Lastname',
    email: 'Email',
    create_a_new_moderator: 'Create a new moderator',
    exhibitors: 'Exhibitors',
    collective: 'Collective',
    events: 'Events',
    password: 'Password',
    phone: 'Phone',
    last_login: 'Last login',
    confirm_remove_user: 'Confirm remove user?',
    company: 'Company',
    add_company: 'Add company',
    confirm_remove_product:
      'If you disable the Hub, the added products will be removed from it. Do you confirm your choice? Confirm Cancel',
    copy: 'Copy',
    copy_admin: 'Copy admin',
    copy_admin_description:
      "Create a new admin with a copy of this admin's exhibitors, moderators, company and related configuration. Events are never copied.",
    copy_admin_fields_required: 'Email and password are required.',
    copy_admin_submit: 'Create copy',
    copy_admin_success: 'Admin copied successfully.',
    copy_admin_error: 'Failed to copy admin.',
    cancel: 'Cancel',
  },
};
